import staticData from "@/api/staticData";

const getDefaultState = () => ({
  staticData: [],
  staticDataLoading: false,
  staticDataError: false,
  staticDataErrorResponse: null,
});

const state = getDefaultState();

const mutations = {
  STATIC_DATA_BEGIN(state) {
    state.staticDataLoading = true;
    state.staticDataError = false;
    state.staticDataErrorResponse = null;
  },
  STATIC_DATA_SUCCESS(state, payload) {
    state.staticData = payload;
    state.staticDataLoading = false;
  },
  STATIC_DATA_ERROR(state, err) {
    state.staticDataLoading = false;
    state.staticDataError = true;
    state.staticDataErrorResponse = err;
  },

  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
}

const actions = {
  async fetchStaticData({ commit }, payload) {
    commit("STATIC_DATA_BEGIN");
   
    try {
      const response = await staticData.getStaticData(payload);
      commit("STATIC_DATA_SUCCESS", response.data);
    } catch (err) {
      commit("STATIC_DATA_ERROR", err);
      throw err;
    }
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  }
}

const getters = {
  getStaticData: (state) => state.staticData,
  getStaticDataLoading: (state) => state.staticDataLoading,
  getStaticDataError: (state) => state.staticDataError,
  getStaticDataErrorResponse: (state) => state.staticDataErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};